import React from 'react';
import { Motion, spring } from 'react-motion';
import { delay } from 'core-js';
// import { Link } from 'react-router-dom';
import slug from 'constants/slug.js';
import { get } from 'lodash';
import { Icon } from '@blueprintjs/core';
import Clearfix from 'components/elements/clearfix';
import styled from 'styled-components';

const markerWidth = 50;
const markerHeight = 60;

const originX = markerWidth;
const originY = markerHeight;

const styleMarker = {
  position: 'absolute',
  cursor: 'pointer',
  width: markerWidth,
  height: markerHeight,
  top: -originY,
  left: -originX,
  transformOrigin: `${originX}px ${originY}px`,
  margin: 0,
  padding: 0,
  zIndex: 10,
};

const textMarker = {
  cursor: 'pointer',
  width: markerWidth,
  top: (markerHeight / 8) * 3,
  left: originX,
  transformOrigin: `${originX} ${originY}`,
  maxWidth: 'inherit',
  zIndex: 10,
};

const defaultScale = 0.6;
const initialScale = 0.3;
const hoveredScale = 0.8;
const springConfig = {
  stiffness: 320,
  damping: 7,
  precision: 0.001,
  val: 0.6,
};

const ItemValue = styled.div`
  font-size: 12px;
  .label {
    font-weight: 600;
    margin-right: 5px;
  }
`;

const RowValue = (props) => {
  return (
    <ItemValue>
      <span className='label'>{props.label}:</span>
      <span>{props.value}</span>
      <Clearfix height={8} />
    </ItemValue>
  );
};

export class Marker extends React.Component {
  state = {
    isHover: false,
    isClicked: false,
    motionStyle: {
      scale: spring(initialScale, springConfig),
    },
  };

  componentWillMount() {
    this.setState({
      isClicked: false,
    });
  }

  getText = () => {
    const { Species } = this.props;
    return get(Species, 'SpeciesName.Name');
  };

  getTextWidth = () => {
    var canvas =
      this.getTextWidth.canvas ||
      (this.getTextWidth.canvas = document.createElement('canvas'));
    var context = canvas.getContext('2d');
    context.font = '300 12pt arial';
    const name = this.getText();
    var metrics = context.measureText(name);
    return metrics.width;
  };

  async componentDidMount() {
    await delay(100);
    this.setState(
      {
        motionStyle: {
          scale: spring(defaultScale, springConfig),
        },
      }
      // async () => {
      //   await delay(500);
      //   this.setState({
      //     motionStyle: {
      //       scale: spring(defaultScale, springConfig)
      //     }
      //   });
      // }
    );
  }

  render() {
    let calWidth = this.getTextWidth();
    const { color, Species, ProjectName } = this.props;
    calWidth = calWidth <= 300 ? calWidth : 300;
    return (
      <React.Fragment>
        <Motion
          defaultStyle={{ scale: defaultScale }}
          style={this.state.motionStyle}
        >
          {/* sử dụng Motion, bên trong Motion luon luon la function tra ve element */}
          {({ scale }) => {
            return (
              <Icon
                icon='map-marker'
                iconSize={70}
                color={color}
                onClick={() => {
                  this.setState({
                    isClicked: !this.state.isClicked,
                  });
                }}
                onMouseEnter={() => {
                  this.setState({
                    isHover: true,
                    motionStyle: {
                      scale: spring(hoveredScale, springConfig),
                    },
                  });
                }}
                onMouseLeave={() => {
                  this.setState({
                    isHover: false,
                    motionStyle: {
                      scale: spring(defaultScale, springConfig),
                    },
                  });
                }}
                style={{
                  ...styleMarker,
                  transform: `translate3D(0,0,0) scale(${scale}, ${scale})`,
                }}
              />
            );
          }}
        </Motion>
        <div
          className='bp3-tag bp3-intent-success bp3-text-overflow-ellipsis'
          style={{
            ...textMarker,
            left: -calWidth / 2,
            width: calWidth + 20,
            fontSize: '12px',
            font: '300 12pt arial',
          }}
        >
          <div
            className='bp3-text-overflow-ellipsis'
            style={{
              width: calWidth,
            }}
          >
            {this.getText()}
          </div>
        </div>
        {this.state.isClicked && (
          <div
            className='bp3-popover bp3-popover-content-sizing'
            style={{
              position: 'absolute',
              left: -150,
              minWidth: 300,
              background: '#fffff',
              bottom: 30,
              zIndex: 30,
            }}
          >
            <div
              className='bp3-popover-arrow'
              style={{
                left: 126,
                bottom: -10,
              }}
            >
              <svg
                viewBox='0 0 30 30'
                style={{
                  transform: `rotate(-90deg)`,
                }}
              >
                <path
                  className='bp3-popover-arrow-border'
                  d='M8.11 6.302c1.015-.936 1.887-2.922 1.887-4.297v26c0-1.378-.868-3.357-1.888-4.297L.925 17.09c-1.237-1.14-1.233-3.034 0-4.17L8.11 6.302z'
                />
                <path
                  className='bp3-popover-arrow-fill'
                  d='M8.787 7.036c1.22-1.125 2.21-3.376 2.21-5.03V0v30-2.005c0-1.654-.983-3.9-2.21-5.03l-7.183-6.616c-.81-.746-.802-1.96 0-2.7l7.183-6.614z'
                />
              </svg>
            </div>
            <div className='bp3-popover-content'>
              <div className='mapInfowindow'>
                <RowValue
                  label='Tên loài'
                  value={get(Species, 'SpeciesName.Name')}
                />
                <RowValue
                  label='Mức độ bảo tồn'
                  value={get(Species, 'SpeciesType.Name')}
                />
                <RowValue
                  label='Tên địa phương'
                  value={get(Species, 'LocalName')}
                />
                <RowValue
                  label='Tên khoa học'
                  value={get(Species, 'ScienceName')}
                />
                <RowValue label='Họ' value={get(Species, 'Surname.Name')} />
                <RowValue label='Bộ' value={get(Species, 'Set.Name')} />
                <RowValue
                  label='Dự án'
                  value={
                    <a
                      target='_blank'
                    style={{ fontSize:14, fontWeight: 700, color: '#37B44C', textDecoration: 'none' }}
                      href={
                        slug.BIODIVERSITY.DETAIL_WITH_ID +
                        Species.BiodiversityID +
                        '/species?speciesID=' +
                        Species._id
                      }
                    >
                      {ProjectName}
                    </a>
                  }
                />
              </div>
            </div>
          </div>
        )}
        {/* <div>Markerfrrrr</div> */}
      </React.Fragment>
    );
  }
}
export default Marker;



// WEBPACK FOOTER //
// ./src/containers/Biodiversity/BiodiversityList/Maps/Marker.js